import duesConstants from "../constants/duesConstants";

const initialState: {
  clientDues: any[];
  clientDuesResponse: any;
  invoiceDues: any;
  clientDuesPending: Boolean;
} = {
  clientDues: [],
  clientDuesResponse: null,

  invoiceDues: null,

  clientDuesPending: false,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case duesConstants.GET_CLIENT_DUES_REQUEST:
      return {
        ...state,
        clientDuesPending: true,
      };
    case duesConstants.GET_CLIENT_DUES_SUCCESS:
      return {
        ...state,
        clientDuesPending: false,
        clientDues: action.payload.data.results,
        clientDuesResponse: action.payload.data,
      };
    case duesConstants.GET_CLIENT_DUES_FAILURE:
      return {
        ...state,
        clientDuesPending: false,
      };

    case duesConstants.GET_INVOICE_DUES_SUCCESS:
      return {
        ...state,
        invoiceDues: action.payload.data,
      };
    case duesConstants.RESET_DUES:
      return {
        ...state,
        clientDues: [],
        clientDuesResponse: null,
      };
    default:
      return {
        ...state,
      };
  }
};
